import { HTMLAttributes } from "react";
import cn from "clsx";

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

/** Pulsierende Platzhalter-Fläche (Spec §3). Größe via className. */
export function Skeleton({ className, ...rest }: SkeletonProps) {
  return (
    <div
      className={cn("animate-pulse bg-surface-3 rounded-md", className)}
      {...rest}
    />
  );
}

export default Skeleton;
